import React, { useEffect, useState } from 'react';
import useTranslate from '../../../../common/hooks/useTranslate';
import { getMediaContent } from '../../../services/homeService';
import { POPUP } from '../../../../redux/types';
import { useDispatch } from 'react-redux';

import { IMediaContent } from '../../../services/types/IMediaContent';

import VideoWidget from '../videoWidget/videoWidget';
import ImageWidget from '../imageWidget/imageWidget';

import './mediaSection.scss';

const MediaSection = () => {
  const [mediaData, setMediaData] = useState<IMediaContent[]>([]);

  const { t } = useTranslate();
  const dispatch = useDispatch();

  useEffect(() => {
    getMediaContent()
      .then((res) => {
        setMediaData(res);
      })
      .catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  }, []);

  return mediaData && mediaData.length > 0 && (
    <section className='media-section'>
      <section className='widgets-container'>
        <div className='widgets-side-wrapper'>
          {mediaData && mediaData.map((media, key) => {
            if (key % 2 === 0) {
              if (media.type === 'video') {
                return (
                  <VideoWidget key={media.id} videoSrc={media.fileUri} title={media.title || media.name} />
                );
              } else {
                return (
                  <ImageWidget type={media.type} key={media.id} imageSrc={media.fileUri} imageFile={media.file}
                               title={media.title || media.name}
                               description={media.description} navigationUrl={media.uri} />
                );
              }
            }
          })}
        </div>
        <div className='widgets-side-wrapper'>
          {mediaData && mediaData.map((media, key) => {
            if (key % 2 === 1) {
              if (media.type === 'video') {
                return (
                  <VideoWidget key={media.id} videoSrc={media.fileUri} title={media.title || media.name} />
                );
              } else {
                return (
                  <ImageWidget type={media.type} key={media.id} imageSrc={media.fileUri} imageFile={media.file}
                               title={media.title || media.name}
                               description={media.description} navigationUrl={media.uri} />
                );
              }
            }
          })}
        </div>
      </section>
    </section>
  );
};
export default MediaSection;